import script from "./CourseSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./CourseSidebarDetails.vue?vue&type=style&index=0&id=f844bf8e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f844bf8e"]])

export default __exports__